import { useState, ChangeEvent, useCallback, useMemo } from 'react';
import { findJobCount } from 'components/OccupationSelectModal/logics/createOccupationDisplayData';
import { JobCountDetailResponse } from '@doda/api-client/aspida/@types';
import { WorkingPlaceEnvironment } from 'types/kodawari';
import { HooksArgument } from 'components/SearchSideBar/types';
import { createInitialWorkplaceEnvironment } from '../../logics/workingPlaceEnvironment/createInitialWorkplaceEnvironment';

/**
 * 会社・職場の環境
 * @param args
 * @returns 表示用配列と更新処理
 */
export const useWorkingPlaceEnvironment = (args: HooksArgument) => {
  const [workingPlaceEnvironmentList, setWorkingPlaceEnvironmentList] =
    useState<WorkingPlaceEnvironment[]>(
      createInitialWorkplaceEnvironment(args)
    );

  const selectedWorkingPlaceEnvironmentList = useMemo(() => {
    return workingPlaceEnvironmentList
      .filter(({ isChecked }) => isChecked)
      .map(({ value }) => value);
  }, [workingPlaceEnvironmentList]);

  const updateIsCheckedWorkingPlaceEnvironmentList = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const checkedList = workingPlaceEnvironmentList.map((item) => {
        if (item.value !== event.target.value) return item;

        return {
          ...item,
          isChecked: event.target.checked,
        };
      });

      setWorkingPlaceEnvironmentList(checkedList);

      return checkedList
        .filter(({ isChecked }) => isChecked)
        .map(({ value }) => value);
    },
    [workingPlaceEnvironmentList]
  );

  const updateWorkingPlaceEnvironmentJobCount = useCallback(
    (
      workingPlaceEnvironmentJobCountList: JobCountDetailResponse[] | undefined
    ) => {
      setWorkingPlaceEnvironmentList((pre) =>
        pre.map((item) => ({
          ...item,
          jobCount: findJobCount(
            workingPlaceEnvironmentJobCountList,
            item.value
          ),
        }))
      );
    },
    []
  );

  return {
    workingPlaceEnvironmentList,
    selectedWorkingPlaceEnvironmentList,
    updateIsCheckedWorkingPlaceEnvironmentList,
    updateWorkingPlaceEnvironmentJobCount,
  };
};
